import { render, staticRenderFns } from "./businessListDetail.vue?vue&type=template&id=f2019868"
import script from "./businessListDetail.vue?vue&type=script&lang=js"
export * from "./businessListDetail.vue?vue&type=script&lang=js"
import style0 from "./businessListDetail.vue?vue&type=style&index=0&id=f2019868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports